// removed by extract-text-webpack-plugin
module.exports = {"container":"_2t_fIi_DVMc0yozD3klEhq","activityNotes":"_2d-pK7X0SleiWqebdHTnx9"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c761689","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/meetings/notepad.less
// module id = MpEB
// module chunks = 1